<template>
  <Collapse class="feedback" :when="collapse"> 
    <div class="knd-uitklap">
      <p v-if="correct !== undefined">{{ correct  ? 'Klopt!' : 'Fout!' }}</p>

      <div class="extra-feedback">
        <slot></slot>
      </div>

      <div 
        v-for="(item, index) in feedback" 
        :key="index">
        <div v-if="item.type && item.type[0].titel === 'tekst'" v-html="item.tekst"></div>

        <div v-if="item.type && item.type[0].titel === 'media'">
          <VideoPart 
            v-if="item.media.video && item.media.video[0]"
            :poster="undefined"
            :controls="true"
            :loop="false"
            :description="''"
            :autoplay="false"
            :src="VUE_APP_PBASE + item.media.video[0]['url']" 
          />

            <ImagePart 
              v-if="item.media.afbeelding"
              :media="item.media.afbeelding" 
              :size="item.media.size"
            />
        </div>
      </div>

      <div class="extra-feedback" v-if="url">
       Lees <a :href="url" target="_blank">hier</a> de hele factcheck.
      </div>
    </div>
  </Collapse>

</template>

<script>

import { reactive, toRefs } from 'vue';
import { Collapse } from 'vue-collapsed';
import VideoPart from '@/components/video';
import ImagePart from '@/components/image';

export default {
	name: 'Uitklap',
  components:{Collapse, VideoPart, ImagePart},
  props: {
    correct: {
      type:Boolean,
      default: undefined
    },
    url: {
      type:String,
      default: undefined
    },    
    feedback: {
      type: Array,
      required: true
    },
    collapse: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      answered: false,
      VUE_APP_PBASE: process.env.VUE_APP_PBASE
    });

    return {
      ...toRefs(state)
    }

  }
}
</script>


<style lang="scss">


</style>